<template>
    <div class="ur-drop-holder ur-input" :class="dropdownClass">
        <div class="ur-drop-holder__holder" @click="toggleItem">
            <!--
                $ver: v0.1.2
                드랍홀더 항목 내부에 위치하는 영역 입니다.
                #This area is located inside the dropholder item.
            -->
            <slot/>
        </div>
        <!-- 
        {value:'m_detail',text:'상세 조회'},
        {value:'m_copy'  ,text:'캠페인 복사'},
        {value:'m_pause' ,text:'캠페인 중지'},
        {value:'m_replay',text:'캠페인 다시 진행'},
        {value:'m_modify',text:'캠페인 수정'},
        {value:'m_cancel',text:'캠페인 취소'},
        {value:'m_delete',text:'캠페인 삭제'}, -->

        <div class="ur-dropdown__items" v-show="isItemShowing" :class="itemsClass" ref='floating' v-ur-attach-root v-click-outside.anchor="toggleItemOuter">
            <ul>
                <div class="ur-dropdown__item" :class="[dropdownItemSize]" v-for="(item, idx) in items" @click.stop="clickItem(item)" :key="idx">
                    <li v-if="item.value==='m_detail'"><strong>{{getText(item)}}</strong></li>                    
                    <li v-else-if="item.value==='m_copy'"><a href="#" class="m_copy">{{getText(item)}}</a></li>
                    <li v-else-if="item.value==='m_pause'"><a href="#" class="m_pause">{{getText(item)}}</a></li>
                    <li v-else-if="item.value==='m_replay'"><a href="#" class="m_replay">{{getText(item)}}</a></li>
                    <li v-else-if="item.value==='m_modify'"><a href="#" class="m_modify">{{getText(item)}}</a></li>
                    <li v-else-if="item.value==='m_cancel'"><a href="#" class="m_cancel">{{getText(item)}}</a></li>
                    <li v-else-if="item.value==='m_delete'"><a href="#" class="m_delete">{{getText(item)}}</a></li>

                    <!-- <div class="ur-dropdown__label" :class="{'ur-dropdown__selected': isSelectedItem(item) }">
                        <span>{{getText(item)}}</span>
                        <ur-icon v-if="item.childItems" class="ur-dropdown__label-caret" size="8px">expand_menu</ur-icon>
                    </div> -->

                    <!-- <div class="ur-dropdown__child-items" v-if="item.childItems">
                        <div class="ur-dropdown__child-item ur-dropdown__label"
                            v-for="(child, childIdx) in item.childItems" :class="{'ur-dropdown__selected': isSelectedItem(child) }" :key="idx + '.' + childIdx"
                            @click.stop="clickItem(child)" :style="itemsWidth">
                            <span>{{getText(child)}}</span>
                        </div>
                    </div> -->

                </div>
            </ul>
        </div>
    </div>
</template>

<script>
const UNSELECT_DROPDOWN_TITLE = "Select";
const DEFAULT_PLACEHOLDER = "Input value";
const DEFAULT_ITEM_TEXT  = "text";
const DEFAULT_ITEM_VALUE = "value";

const NOT_SELECTED = -1;
const NEED_CHECK   = -2;

import urDropdown from "../../../../node_modules/uidev-component/components/element/urDropdown/urDropdown";

// ur-drop-holder는 ur-dropdown과 사용처 및 방법이 흡사하며, 단 아이콘으로 해당 컴포넌트가 보여지게 됩니다.
// #The ur-drop-holder is similar in use and method to ur-dropdown, but the component is shown as an icon.
export default {
    name :"ur-custom-drop-holder",
    extends: urDropdown,
    props: {
        // $ver: v0.2.0
        // 선택목록이 오른쪽에 그려지도록 합니다.
        // #Dropdown would be rendered right side.
        // $tags: IDE
        rightAlign  : {type: Boolean, default: false},

        labelNoWrap : {type: Boolean, default: false},

        itemWidth   : {type: [Number, String], default: 160},
    },
    computed: {
        itemsClass() {
            let clazz = [];
            if(this.hasChildItems) {clazz.push("ur-drop-holder__items--has-child-items");}
            if(this.rightAlign)    {clazz.push("ur-drop-holder__items--right-align");}
            if(this.labelNoWrap)   {clazz.push("ur-drop-holder__items--label-no-wrap");} // todo: 확인필요. 클래스 유무에 따른 동작이나 스타일상 차이가 없음.
            return clazz;
        },
        dropdownClass() {
            return {
                'ur-drop-holder--disabled': this.disabled,
                'ur-drop-holder--medium': this.$_size === 'medium',
                'ur-drop-holder--small': this.$_size === 'small',
                'ur-validator--error': this.hasError === true,
                'ur-validator--valid': this.showValid && this.hasError === false,
                'ur-validator--shake': this.shake
            }
        },
        dropdownItemSize(){
            return {
                'ur-dropdown__item--medium': this.$_size === 'medium',
                'ur-dropdown__item--small': this.$_size === 'small',
            }
        },
    },

    created() {

    },

    mounted() {
      
    },
}
</script>

<style scoped>

</style>